import React, { createContext, useState, useEffect, useContext } from "react";

interface DataContextProps {
  data5: any[];
  tempoMedio7dias: any[];
  especialidades: any[];
  detalhado: Detalhado;
  listOptinsEspecialidades: any[];
  selectedEspecialidades: any;
  setSelectedEspecialidade: any;
  selectedHospital: any;
  setSelectedHospital: any;
  metricasEspecialidades: any;
  macrorregiaoColorMap: any;
  especialidadesColorMap: any;

  loading: boolean;
}

interface Detalhado {
  [hospital: string]: {
    [especialidade: string]: any;
  };
}

const DataContext = createContext<DataContextProps | undefined>(undefined);

const DataProvider: React.FC = ({ children }: any) => {
  // const [data, setData] = useState<any[]>([]);
  const [data5, setData5] = useState<any[]>([]);
  const [tempoMedio7dias, setTempoMedio7dias] = useState<any[]>([]);
  const [especialidades, setEspecialidades] = useState<any>([]);
  const [detalhado, setDetalhado] = useState<Detalhado>({});
  const [selectedEspecialidades, setSelectedEspecialidade] =
    useState<any>("Clinica Médica");
  const [selectedHospital, setSelectedHospital] = useState<any>("Todos");
  const [listOptinsEspecialidades, setListOptinsEspecialidades] = useState<any>(
    []
  );
  const [metricasEspecialidades, setMetricasEspecialidades] = useState<any[]>(
    []
  );

  const [loading, setLoading] = useState<boolean>(true);
  const [reloader, setReloader] = useState(false);

  const teste: any[] = [];

  const hospitais = [
    "HRT",
    "HRSam",
    "HRC",
    "HRBz",
    "HSVP",
    "HRG",
    "HRGu",
    "HRAN",
    "HMIB",
    "HRS",
    "HRL",
    "HRPL",
  ];

  const macrorregioesColors = {
    macrorregiao1: "#527d9b",
    macrorregiao2: "#ff80cc",
    macrorregiao3: "#af6c9c",
  };
  const macrorregiaoColorMap = {
    HRBz: macrorregioesColors.macrorregiao1,
    HRC: macrorregioesColors.macrorregiao1,
    HRSam: macrorregioesColors.macrorregiao1,
    HSVP: macrorregioesColors.macrorregiao1,
    HRT: macrorregioesColors.macrorregiao1,
    HRGu: macrorregioesColors.macrorregiao2,
    HRG: macrorregioesColors.macrorregiao2,
    HMIB: macrorregioesColors.macrorregiao2,
    HRAN: macrorregioesColors.macrorregiao2,
    HRPL: macrorregioesColors.macrorregiao3,
    HRS: macrorregioesColors.macrorregiao3,
    HRL: macrorregioesColors.macrorregiao3,
  };

  const especialidadesColorMap = {
    "Cirurgia Geral": "#d8600e",
    "Clinica Médica": "#8942df",
    Ortopedia: "#4fdd8d",
    Pediatria: "#8791c3",
    "Gineco Obstetrícia": "#c37881",
    Odontologia: "#f3a930",
    Oftalmologia: "#3b8bba",
    Cardiologia: "#e74c3c",
    Psiquiatria: "#6a4c93",
    "Cirurgia Plástica": "#d16d2c",
    "Cirurgia Pediátrica": "#f1c40f",
    "Emergência Clínica": "#2ecc71",
    Observação: "#8e44ad",
    "Pronto Socorro": "#1abc9c",
    Queimados: "#9b59b6",
    "Sala De Infusao": "#e67e22",
    "Sala Vermelha Clinica": "#3498db",
    "Medicação Dia": "#9b59b6",
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const urls = [
          // "https://painel-hospitais-back.saude.df.gov.br/hospitais_detalhes?format=json",
          // "https://painel-hospitais-back.saude.df.gov.br/hospitais?format=json",
          // "https://painel-hospitais-back.saude.df.gov.br/hospitais30?format=json",
          // "https://painel-hospitais-back.saude.df.gov.br/resumo?format=json",
          "https://painel-hospitais-back.saude.df.gov.br/hospitais_detalhes_esp",
          "https://painel-hospitais-back.saude.df.gov.br/hospitais_detalhes_esp_bruto?format=json",
          "https://painel-hospitais-back.saude.df.gov.br/hospitais_detalhes_esp_detalhado?format=json",
        ];

        const requests = urls.map((url) => fetch(url));
        const responses = await Promise.all(requests);

        const allStatus200 = responses.every(
          (response) => response.status === 200
        );

        if (allStatus200) {
          const data = await Promise.all(
            responses.map((response) => response.json())
          );

          const allNonEmpty = data.every((item) => item.length > 0);

          if (allNonEmpty) {
            // setData(data[0]);
            // setData2(data[1]);
            // setData3(data[2]);
            // setData4(data[3]);

            // if (data[4]) {
            //   const modifiedArray = modifyArray(data[4]);
            if (data[0]) {
              const modifiedArray = modifyArray(data[0]);
              // Inicializa o objeto com cada hospital como uma chave com um array vazio
              const resultadoPorHospital: any = hospitais.reduce(
                (acc: any, hospital) => {
                  acc[hospital] = [];
                  return acc;
                },
                {}
              );

              // Popula os arrays conforme o hospital
              modifiedArray.forEach((item: any) => {
                if (resultadoPorHospital[item.i_desc_local_passagem]) {
                  resultadoPorHospital[item.i_desc_local_passagem].push(item);
                }
              });

              processarDados(resultadoPorHospital);

              setData5(resultadoPorHospital);

              setMetricasEspecialidades(resultadoPorHospital);
            }

            if (data[1]) {
              const modifiedArray = modifyArray(data[1]);
              // Inicializa o objeto com cada hospital como uma chave com um array vazio
              const resultadoPorHospital: any = hospitais.reduce(
                (acc: any, hospital) => {
                  acc[hospital] = [];
                  return acc;
                },
                {}
              );

              // Popula os arrays conforme o hospital
              modifiedArray.forEach((item: any) => {
                if (resultadoPorHospital[item.i_desc_local_passagem]) {
                  resultadoPorHospital[item.i_desc_local_passagem].push(item);
                }
              });

              // console.log("resultadoPorHospital", resultadoPorHospital);

              const ultimaSemana = true;
              processarDados(resultadoPorHospital, ultimaSemana);

              setTempoMedio7dias(resultadoPorHospital);
            }

            setLoading(false);

            setTimeout(() => setReloader(!reloader), 30000);
          }
          if (data[2]) {
            const modifiedArray = modifyArray(data[2]);
            // Inicializa o objeto com cada hospital como uma chave com um array vazio
            const resultadoPorHospital: any = hospitais.reduce(
              (acc: any, hospital) => {
                acc[hospital] = [];
                return acc;
              },
              {}
            );

            // Popula os arrays conforme o hospital
            modifiedArray.forEach((item: any) => {
              if (resultadoPorHospital[item.i_desc_local_passagem]) {
                resultadoPorHospital[item.i_desc_local_passagem].push(item);
              }
            });

            processarDados(resultadoPorHospital);

            setDetalhado(resultadoPorHospital);
          } else {
            console.log("Erro na requisição de algum endpoint");
            setTimeout(() => setReloader(!reloader), 300000);
          }
        } else {
          console.log("Alguma requisição não retornou 200");
          setTimeout(() => setReloader(!reloader), 300000);
        }
      } catch (err) {
        console.log("Erro em todas as requisições");
        setTimeout(() => setReloader(!reloader), 300000);
      }
    };
    fetchData();
  }, [reloader]);

  const toTitleCase = (str: any) => {
    // // Remove aspas da string
    // const cleanedStr = str.replace(/"/g, "").trim();

    // // Divide a string em partes usando espaço, hífen ou barra como separadores (mantém espaços)
    // const parts = cleanedStr.split(/[\s\-\/]/);

    // // Transforma cada palavra com a primeira letra maiúscula e o restante em minúsculas
    // const titleCaseStr = parts
    //   .map((part: any) => {
    //     return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    //   })
    //   .join(" ");

    // return titleCaseStr;

    // Remove aspas da string e espaços extras ao redor
    const cleanedStr = str.replace(/"/g, "").trim();

    // Divide a string em partes usando espaço, hífen ou barra como separadores (mantém espaços)
    const parts = cleanedStr.split(/[\s\-\/]/);

    // Remove espaços vazios que estejam como a primeira parte
    if (parts[0] === "") {
      parts.shift(); // Remove o primeiro elemento se for um espaço vazio
    }

    // Transforma cada palavra com a primeira letra maiúscula e o restante em minúsculas
    const titleCaseStr = parts
      .map((part: any) => {
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
      })
      .join(" ");

    return titleCaseStr;
  };

  const modifyArray = (arr: any) => {
    const seenValues = new Set();

    return arr
      .map((item: any) => {
        // Desestruturação para criar uma cópia do objeto
        const { i_desc_local_passagem_completa } = item;

        // Verifica se o valor é "Pronto Socorro" ou "- PRONTO SOCORRO"
        const isProntoSocorro =
          i_desc_local_passagem_completa.toLowerCase() === "pronto socorro" ||
          i_desc_local_passagem_completa.toLowerCase() === "- pronto socorro";

        // Define o valor padronizado para "Pronto Socorro" ou mantém o valor original
        let newValue = isProntoSocorro
          ? "Pronto Socorro"
          : i_desc_local_passagem_completa;

        // Condição adicional para transformar "Clinica Medica" em "Clinica Médica"
        if (newValue.toLowerCase() === "clinica medica") {
          newValue = "Clinica Médica";
        }

        if (
          newValue.toLowerCase() === " pronto socorro" ||
          newValue.toLowerCase() === "hrlpronto socorro fila adulto" ||
          newValue.toLowerCase() === "  pronto socorro"
        ) {
          newValue = "Pronto Socorro";
        }

        if (newValue.toLowerCase() === " clinica medica") {
          newValue = "Clinica Médica";
        }

        if (
          newValue.toLowerCase() === "gineco/obstetricia" ||
          newValue.toLowerCase() === " gineco/obstetricia"
        ) {
          newValue = "Gineco Obstetrícia";
        }

        // Condição para transformar "Gineco Obstetricia" em "Gineco Obstetrícia"
        if (
          newValue.toLowerCase() === "gineco-obstetrico" ||
          newValue.toLowerCase() === " gineco-obstetrico"
        ) {
          newValue = "Gineco Obstetrícia";
        }

        if (
          newValue.toLowerCase() === "gineco/obstetrica" ||
          newValue.toLowerCase() === " gineco/obstetrica"
        ) {
          newValue = "Gineco Obstetrícia";
        }

        if (newValue.toLowerCase() === "ginecoobstetrico") {
          newValue = "Gineco Obstetrícia";
        }

        if (newValue.toLowerCase() === "medicacao dia") {
          newValue = "Medicação dia";
        }

        // Converte para title case e remove aspas
        const titleCaseValue = toTitleCase(newValue);

        // Se já existir "Pronto Socorro" no Set e o valor atual for uma variante de "Pronto Socorro", não adiciona
        if (
          titleCaseValue === "Pronto Socorro" &&
          seenValues.has("Pronto Socorro")
        ) {
          return null; // Retorna null para ignorar essa entrada
        }

        // Adiciona o valor ao Set para evitar duplicatas
        seenValues.add(titleCaseValue);

        return {
          ...item,
          i_desc_local_passagem_completa: titleCaseValue,
        };
      })
      .filter(Boolean); // Filtra itens que foram marcados como null para removê-los
  };

  // Função para agrupar os objetos por 'i_desc_local_passagem_completa'
  function agruparPorDescLocalPassagemCompleta(hospitalData: any) {
    const agrupado: any = {};

    hospitalData.forEach((item: any) => {
      const key = item.i_desc_local_passagem_completa;

      if (!agrupado[key]) {
        agrupado[key] = [];
      }

      teste.push(key);

      agrupado[key].push(item);
    });

    return agrupado;
  }

  const createArrayWithLabelValue = (arr: any) => {
    // Set para rastrear valores únicos

    return arr.reduce((acc: any, item: any) => {
      // Se o valor já existir no Set, ignorar e não adicionar ao array

      acc.push({ label: item, value: item });

      return acc;
    }, []);
  };

  // Função principal para percorrer todos os hospitais e aplicar o agrupamento
  function processarDados(data: any, ultimaSemana: boolean = false) {
    Object.keys(data).forEach((hospital) => {
      const hospitalData = data[hospital];
      const agrupado = agruparPorDescLocalPassagemCompleta(hospitalData);
      data[hospital] = agrupado;
      const uniqueItems = Array.from(new Set(teste));

      if (!ultimaSemana) {
        const especialidadesTratadas = [...especialidades, ...uniqueItems];

        setEspecialidades(Array.from(new Set(especialidadesTratadas)));

        const valorEspecialidades = createArrayWithLabelValue(uniqueItems);

        const sortedArray = valorEspecialidades.sort((a: any, b: any) => {
          return a.label.localeCompare(b.label);
        });

        setListOptinsEspecialidades(sortedArray);
      }
    });
  }

  return (
    <DataContext.Provider
      value={{
        data5,
        tempoMedio7dias,
        especialidades,
        detalhado,
        loading,
        selectedEspecialidades,
        setSelectedEspecialidade,
        selectedHospital,
        setSelectedHospital,
        listOptinsEspecialidades,
        metricasEspecialidades,
        macrorregiaoColorMap,
        especialidadesColorMap,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export { DataContext, DataProvider };

export const useDataContext = () => {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error("useDataContext must be used within a DataProvider");
  }
  return context;
};
